import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
/** @jsx jsx */

import { jsx } from 'theme-ui';
import { jsx as ___EmotionJSX } from "@emotion/core";

var heading = function heading(Tag) {
  var Component = function Component(props) {
    return !!props.id ? jsx(Tag, props, jsx("a", {
      href: "#" + props.id,
      sx: {
        color: 'inherit',
        textDecoration: 'none',
        ':hover': {
          textDecoration: 'underline'
        }
      }
    }, props.children)) : jsx(Tag, props);
  };

  Component.displayName = Tag;
  return Component;
};

export var h2 = heading('h2');

if (typeof h2 !== 'undefined' && h2 && h2 === Object(h2) && Object.isExtensible(h2) && !h2.hasOwnProperty('__filemeta')) {
  Object.defineProperty(h2, '__filemeta', {
    configurable: true,
    value: {
      name: "h2",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Headings/index.js"
    }
  });
}

export var h3 = heading('h3');

if (typeof h3 !== 'undefined' && h3 && h3 === Object(h3) && Object.isExtensible(h3) && !h3.hasOwnProperty('__filemeta')) {
  Object.defineProperty(h3, '__filemeta', {
    configurable: true,
    value: {
      name: "h3",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Headings/index.js"
    }
  });
}

export var h4 = heading('h4');

if (typeof h4 !== 'undefined' && h4 && h4 === Object(h4) && Object.isExtensible(h4) && !h4.hasOwnProperty('__filemeta')) {
  Object.defineProperty(h4, '__filemeta', {
    configurable: true,
    value: {
      name: "h4",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Headings/index.js"
    }
  });
}

export var h5 = heading('h5');

if (typeof h5 !== 'undefined' && h5 && h5 === Object(h5) && Object.isExtensible(h5) && !h5.hasOwnProperty('__filemeta')) {
  Object.defineProperty(h5, '__filemeta', {
    configurable: true,
    value: {
      name: "h5",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Headings/index.js"
    }
  });
}

export var h6 = heading('h6');

if (typeof h6 !== 'undefined' && h6 && h6 === Object(h6) && Object.isExtensible(h6) && !h6.hasOwnProperty('__filemeta')) {
  Object.defineProperty(h6, '__filemeta', {
    configurable: true,
    value: {
      name: "h6",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Headings/index.js"
    }
  });
}